module.exports = __webpack_public_path__ + "static/media/door_closed.398fe979.png";